import { BaseResponse } from '../../../../../../../../types/api/api.types';
import { PROSPECT_ENDPOINTS } from '../../../../../../../../utils/api/endpoints/prospectEndpoints';
import { UpdateStatusProspectWithCommentQuery } from './UpdateStatusProspectForm.types';

const UPDATE_PREFIX = '[updateStatusProspectWithCommentQuery]';

export const UPDATE_PROSPECT_STATUS_WITH_COMMENT_QUERY_KEY = 'UPDATE_PROSPECT_STATUS_WITH_COMMENT';

export const updateStatusProspectWithCommentQuery = async (
  data: UpdateStatusProspectWithCommentQuery
) => {
  console.log(UPDATE_PREFIX, `Updating prospect status...`);
  const response = await PROSPECT_ENDPOINTS.updateStatusWithComment(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(UPDATE_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(UPDATE_PREFIX, `Updated prospect status.`);
  return json as BaseResponse;
};
